export default "__VITE_ASSET__yZ85WoUG__"